import { call, put, takeLatest } from 'redux-saga/effects';

import { receiveAPIResponse, requestAPIFailed } from 'src/redux/api/actions';
import { apiCallAsync } from 'src/redux/api/saga';
import { ICONS_DETAILS_ACTION, ICONS_DETAILS_KEY } from 'src/redux/constants';
import type { ViewAction } from 'src/redux/viewState/types';
import { getActionAPISource } from 'src/utils';

export function* getIconsDetailsSaga(action: ViewAction) {
  try {
    let url = getActionAPISource(ICONS_DETAILS_KEY);
    url = url.replace(new RegExp('_id_', 'g'), action.value);
    const response = yield call(apiCallAsync, url, action.value, 'get');
    if (response.status === 200) {
      yield put(receiveAPIResponse(ICONS_DETAILS_KEY, response.data));
    } else {
      throw 'API call has failed';
    }
  } catch (e) {
    yield put(requestAPIFailed(action.dataKey, e.toString()));
    console.error(e);
  }
}

export function* watchIconsDetailsSaga() {
  yield takeLatest(ICONS_DETAILS_ACTION, getIconsDetailsSaga);
}
